class ContactForm extends HTMLElement {
  constructor() {
    super();
    
    this.form = this.querySelector('form')
    this.pristine = new Pristine(this.form);
    this.handleSubmit();
  }

  handleSubmit() {
    this.form.addEventListener("submit", (event) => {
      event.preventDefault();
      this.pristineValidation();

      if (this.pristine.validate()) {
        this.submit();
      }
    });
  }

  pristineValidation() {
    if (!this.pristine.validate()) {
      
      this.pristine.fields.forEach((field, index) => {
        if (field.errors.length) {
          const errorContainer = field.input.parentNode.querySelector('[data-form-validation-message]');
          errorContainer.textContent = field.errors[0];
          errorContainer.classList.remove('hidden');

          field.input.addEventListener('input', () => {
            if (this.pristine.fields[index].errors.length === 0) {
              errorContainer.classList.add('hidden');
            }
          })
        }
      })
    }
  }

  submit() {
    const formData = new FormData(this.form);
    const xhr = new XMLHttpRequest();

    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status >= 200 && xhr.status < 300) {
          this.setCompleted();
        } else {
          console.error("Error: ", xhr.status, xhr.statusText);
          this.querySelector('[data-form-error-message]').classList.remove('hidden');
        }
      }
    };

    xhr.open("POST", this.form.action, true);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.send(formData);
  }

  setCompleted() {
    const button = this.querySelector('.button[type="submit');
    const fields = this.form.querySelectorAll('input, textarea');
    const buttonSubmittedText =  button.dataset.buttonSubmittedText;

    this.classList.add('submitted');
    button.setAttribute('disabled','')

    if (buttonSubmittedText) {
      button.textContent = buttonSubmittedText;
    }

    fields.forEach(field => {
      field.setAttribute('disabled', '');
    })
  }
}

customElements.define('contact-form', ContactForm);
